import omit from 'lodash-es/omit';

import { encodeQuery, parseSearch } from './urlQuery';

export const JANE_SEARCH_STATE_KEYS = [
  'bucketFilters',
  'currentSort',
  'filters',
  'page',
  'rangeFilters',
  'searchText',
];

export const INSTANTSEARCH_STATE_KEYS = [
  'refinementList',
  'multiRange',
  'range',
];

export const getLocationQueryWithoutSearchState = (
  locationSearch: string
): string => {
  const currentParams = parseSearch(locationSearch);
  return encodeQuery(
    '',
    omit(currentParams, [
      ...JANE_SEARCH_STATE_KEYS,
      ...INSTANTSEARCH_STATE_KEYS,
    ])
  );
};
